import {
  CREATE_ACCOUNT_RECEIVABLES,
  FETCH_ALL_ACCOUNT_RECEIVABLES,
} from "../actions/constants";

const accountReceivables = (state = { accountReceivables: [] }, action) => {
  switch (action.type) {
    case FETCH_ALL_ACCOUNT_RECEIVABLES:
      return {
        ...state,
        accountReceivables: action.payload,
      };

    case CREATE_ACCOUNT_RECEIVABLES:
      return {
        ...state,
        accountReceivables: [...state.accountReceivables, action.payload],
      };

    default:
      return state;
  }
};

export default accountReceivables;
